import { PaymentDetailsWithRequiredAccountSelectionSchema } from '../schemas/payment';
import type { GlobalApiPaymentDetails } from '../types/payment';

export function getAccountsList(
  paymentDetails: GlobalApiPaymentDetails | null | undefined
) {
  const validationResult =
    PaymentDetailsWithRequiredAccountSelectionSchema.safeParse(paymentDetails);

  if (!validationResult.success) {
    return null;
  }

  return validationResult.data.paymentInitiationFlow.requiredInput[0];
}
